import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { LoadingSpinner } from '../../core/LoadingSpinner';
import { CustomeTextField } from '../../generic/CustomeTextField';
import { uploadFetch } from '../../hooks/useFetch';
import { IDocumentDirectory } from '../../Interfaces/IDocumentDirectory';
import { IDocumentDirectoryHasDocument } from '../../Interfaces/IDocumentDirectoryHasDocument';
import { ISearchAPI } from '../../Interfaces/ISearchAPI';
import { State } from '../../redux/mainReducer';
import { ILandParcelEntry } from '../../Interfaces/IRealEstate';
import { ILandMarking } from '../../Interfaces/ILandMarking';
import { useGetFederalStateLogins } from '../../hooks/reactQuerys/FederalStateLoginQueries';
import { useFederalStates } from '../../Aemter/hooks';
import { useGetUsers } from '../../hooks/data';

interface IPayload {
  idDistrictCourt: null | number;
  idLandMarking: null | number;
  Court: null | string;
  Marking: null | string;
  SearchString: null | string;
  Street: null | string;
  DownloadArray: IResult[];
  Parcel: null | string;
  LandParcel: null | string;
  SheetLandRegister: null | string;
  idFederalStateLogin: null | number;
  idRealEstateLandRegisterEntry: null | number;
}

export interface IResult {
  Landregister: string;
  SheetNumber: string;
  Marking: string;
  CadastralDistrict: string;
  CadastralUnit: string;
  Location: string;
  OrderNumber: string;
  Ges: string;
  LastName: string;
  FirstName: string;
  Birthname: string;
  Birthday: string;
}

interface IResultPasswordShouldBeChanged {
  PasswordShouldBeChanged: boolean;
}

interface IResultDownload {
  DocumentDirectory: IDocumentDirectory;
  DocumentArray: IDocumentDirectoryHasDocument[];
  LandParcelEntryArray: ILandParcelEntry[];
}

interface IProps {
  idLegalTransaction: number;
  documentArray: IDocumentDirectoryHasDocument[];
  documentDirectoryArray: IDocumentDirectory[];
  setDocumentArray: Function;
  setDocumentDirectoryArray: Function;
  landParcelEntry?: ILandParcelEntry;
  addressSearchString?: string;
  callOnSuccess?: Function;
}

export const LandregisterSerach: React.FC<IProps> = ({
  idLegalTransaction,
  documentArray,
  documentDirectoryArray,
  setDocumentArray,
  setDocumentDirectoryArray,
  landParcelEntry,
  addressSearchString,
  callOnSuccess,
}) => {
  const is_enabled_landregister =
    localStorage.getItem('is_enabled_landregister') === 'true';
  //
  // LAde vom BAckend
  const districtCourtArray = useSelector(
    (state: State) => state.districtCourtArray.storeDistrictCourt
  );
  const landMarkingArray = useSelector(
    (state: State) => state.landMarkingArray.storeLandMarking
  );
  const { federalStateLogins, isFederalStateLogins } =
    useGetFederalStateLogins();
  const { federalStates, isLoadingFederalStates } = useFederalStates();
  const { users, isLoadingUsers } = useGetUsers();
  //
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  //
  const [passwordShouldBeChanged, setPasswordShouldBeChanged] = useState(false);
  //
  const [landregisterSearch, setLandregisterSearch] = useState({
    Payload: null,
    Results: null,
    Cookies: [],
    idLegalTransaction: idLegalTransaction,
  } as ISearchAPI);
  const [isResultLoading, setIsResultLoading] = useState(false);
  const [resultArray, setResultArray] = useState<IResult[] | null>(null);
  const [wasSuccessfully, setWasSuccessfully] = useState(true);
  //
  const [isOpenDownloadWarning, setIsOpenDownloadWarning] = useState(false);
  const [downloadPayload, setDownloadPayload] = useState<IResult[]>([]);
  const [downloadResult, setDownloadResult] = useState<IResultDownload | null>(
    null
  );
  //
  const [isOpenWasDownloaded, setIsOpenWasDownloaded] = useState(false);

  const getLandMarking = (): ILandMarking | null => {
    if (landParcelEntry != undefined) {
      const test = landMarkingArray.find(
        land =>
          land.LandMarking.toLocaleLowerCase().includes(
            landParcelEntry.LandRegister.toLocaleLowerCase()
          ) ||
          landParcelEntry.LandRegister.toLocaleLowerCase().includes(
            land.LandMarking.toLocaleLowerCase()
          )
      );

      if (test === undefined) {
        return null;
      } else {
        return test;
      }
    }
    return null;
  };
  const getIdLandMarking = () => {
    const test = getLandMarking();
    if (test) {
      return test.idLandMarking;
    } else {
      return null;
    }
  };
  const getDistrict = () => {
    const test = getLandMarking();
    if (test) {
      const testDistrict = districtCourtArray.find(
        dis => dis.idDistrictCourt === test.idDistrictCourt
      );
      if (testDistrict === undefined) {
        return null;
      } else {
        return testDistrict;
      }
    }
    return null;
  };
  const getIdDistrict = () => {
    const test = getDistrict();
    if (test) {
      return test.idDistrictCourt;
    }
    return null;
  };

  // Hilfsvarbiablen für Zugangssuche
  const [idFedearalState, setIdFedearalState] = useState(-1);
  const [idNotaryUser, setIdNotaryUser] = useState(-1);
  //
  const [payloadObject, setPayloadObject] = useState<IPayload>((): IPayload => {
    if (landParcelEntry == undefined) {
      return {
        idDistrictCourt: null,
        idLandMarking: null,
        Court: null,
        Marking: null,
        SearchString: null,
        DownloadArray: [],
        Street: addressSearchString === undefined ? null : addressSearchString,
        LandParcel: null,
        Parcel: null,
        SheetLandRegister: null,
        idFederalStateLogin: null,
        idRealEstateLandRegisterEntry: null,
      };
    } else {
      const currentDistrict = getDistrict();

      if (currentDistrict !== undefined) {
        const currentFederalState = federalStates?.find(
          federalState =>
            federalState.FederalState == currentDistrict?.FederalState
        );
        if (currentFederalState) {
          setIdFedearalState(currentFederalState.idFederalState);
        }
      }

      return {
        idDistrictCourt: getIdDistrict(),
        idLandMarking: getIdLandMarking(),
        Court: getDistrict() === null ? null : getDistrict()!.Court,
        Marking:
          getLandMarking() === null ? null : getLandMarking()!.LandMarking,
        SearchString: null,
        DownloadArray: [],
        Street: addressSearchString === undefined ? null : addressSearchString,
        LandParcel: landParcelEntry.LandParcel,
        Parcel: landParcelEntry.Parcel,
        SheetLandRegister: null,
        idFederalStateLogin: null,
        idRealEstateLandRegisterEntry:
          landParcelEntry.idRealEstateLandRegisterEntry,
      };
    }
  });
  //

  ///// Starten der Suche
  const handleLoadLandregister = () => {
    handleResetSearch();
    setIsOpenSearch(true);
  };

  ///// Starten der Suche
  const hanldeCloseDialog = () => {
    setIsOpenWasDownloaded(false);
    //handleResetSearch();
    //setIsOpenSearch(false);
  };

  ///// Suche und Verarbeiten der Rückgate
  const handleREsSearch = (res: IResult[] | IResultPasswordShouldBeChanged) => {
    if ('PasswordShouldBeChanged' in res) {
      setPasswordShouldBeChanged(true);
    } else {
      setResultArray(res);
    }
  };

  const handleSearch = () => {
    setResultArray(null);
    setDownloadPayload([]);
    setWasSuccessfully(true);

    const uplodObject = {
      ...landregisterSearch,
      Payload: payloadObject,
    };
    uploadFetch(
      '/landregister/search',
      true,
      uplodObject,
      handleREsSearch,
      setWasSuccessfully,
      () => {},
      setIsResultLoading
    );
  };

  ///// Zurücksetzen der Suche
  const handleResetSearch = () => {
    // Zurücksetzen der Suche-States
    setResultArray(null);
    setDownloadPayload([]);
    setPayloadObject({
      idDistrictCourt: null,
      idLandMarking: null,
      Court: null,
      Marking: null,
      SearchString: null,
      DownloadArray: [],
      Street: null,
      LandParcel: null,
      Parcel: null,
      SheetLandRegister: null,
      idFederalStateLogin: null,
      idRealEstateLandRegisterEntry:
        landParcelEntry === undefined
          ? null
          : landParcelEntry.idRealEstateLandRegisterEntry,
    });
    setDownloadResult(null);
    // Schließen der optionalen Dialoge
    setIsOpenDownloadWarning(false);
    setIsOpenWasDownloaded(false);
    // Zurücksetzten der Healthy-States
    setWasSuccessfully(true);
    setIsResultLoading(false);
  };

  ///// Download und Verarbeiten
  const handleResDownload = (
    res: IResultDownload | IResultPasswordShouldBeChanged
  ) => {
    setIsOpenDownloadWarning(false);
    setIsOpenWasDownloaded(true);
    console.log('f');
    if ('PasswordShouldBeChanged' in res) {
      console.log('secend');
      setPasswordShouldBeChanged(true);
    } else {
      setDownloadResult(res);
      if (callOnSuccess !== undefined) {
        callOnSuccess(res.DocumentArray, res.LandParcelEntryArray);
      }

      /// if: Suchen und ORdner ggf. hinzufügen
      const foundDirectory = documentDirectoryArray.find(
        x => x.idDocumentDirectory === res.DocumentDirectory.idDocumentDirectory
      );
      if (foundDirectory === undefined) {
        setDocumentDirectoryArray([
          ...documentDirectoryArray,
          res.DocumentDirectory,
        ]);
      }
      // Hinzufügen der (neuen) Documente
      setDocumentArray([...documentArray, ...res.DocumentArray]);
    }
  };

  const handleDownloadDocument = () => {
    const uplodObject = {
      ...landregisterSearch,
      Payload: {
        ...payloadObject,
        DownloadArray: downloadPayload,
      },
    };
    if (landParcelEntry) {
      uplodObject['Payload']['idRealEstateLandRegisterEntry'] =
        landParcelEntry.idRealEstateLandRegisterEntry;
    }

    setIsOpenDownloadWarning(false);
    //setResultArray(null);
    uploadFetch(
      '/landregister/download',
      true,
      uplodObject,
      handleResDownload,
      setWasSuccessfully,
      () => {},
      setIsResultLoading
    );
  };

  if (isFederalStateLogins || isLoadingFederalStates || isLoadingUsers) {
    return <CircularProgress />;
  }

  if (!federalStateLogins || !federalStates || !users) {
    return <Alert severity='error'>Es ist ein Fehler aufgetretten!</Alert>;
  }

  return (
    <>
      <Dialog open={isOpenWasDownloaded} onClose={hanldeCloseDialog}>
        <DialogTitle>Download bestätigen</DialogTitle>
        <DialogContent>
          <Alert severity='success'>
            <AlertTitle>Grundbuchauszüge wurden bezogen!</AlertTitle>
            Es wurden die folgen Dokumente zum Ordner <i>Grundbuchauszüge</i> in
            der <u>internen Datenablage</u> hinzugefügt:
            <ul>
              {downloadResult?.DocumentArray.map(x => (
                <li>{x.FileName}</li>
              ))}
            </ul>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' onClick={hanldeCloseDialog}>
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isOpenDownloadWarning}
        onClose={() => setIsOpenDownloadWarning(false)}
      >
        <DialogTitle>Download bestätigen</DialogTitle>
        <DialogContent>
          <Alert severity='warning'>
            <AlertTitle>Achtung: Kostenpflichtig!</AlertTitle>
            Für jeden Bezug eines Grundbucheintrags fallen kosten an.
            <br />
            Sind Sie sich sicher, dass Sie {downloadPayload.length}{' '}
            Grundbucheinträge beziehen wollen?
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={handleDownloadDocument}>
            Beziehen
          </Button>
          <Button
            variant='contained'
            onClick={() => setIsOpenDownloadWarning(false)}
          >
            Abbruch
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={passwordShouldBeChanged}
        onClose={() => setPasswordShouldBeChanged(false)}
      >
        <DialogContent>
          <Alert severity='info'>
            <AlertTitle>Die Zugangsdaten sind abgelaufen!</AlertTitle>
            Sie müssen in SolumWEB das Kennwort aktualisieren.
            <br /> Kontaktieren Sie dafür einen Administrator.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            variant='contained'
            onClick={() => setPasswordShouldBeChanged(false)}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ m: 2, mb: 2 }}>
        <Card variant='outlined'>
          <Typography variant='caption' sx={{ ml: 1 }}>
            Zugangsdaten
          </Typography>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  //type="email"
                  variant='outlined'
                  label='Bundesland'
                  fullWidth
                  value={idFedearalState < 0 ? '' : idFedearalState}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setIdFedearalState(Number(event.target.value));
                    setIdNotaryUser(-1);
                    setPayloadObject({
                      ...payloadObject,
                      idFederalStateLogin: null,
                    });
                  }}
                  required
                  select
                  size='small'
                >
                  {federalStates
                    .filter(
                      federalState => federalState.isEnabledSolumWeb == true
                    )
                    .map(federalState => (
                      <MenuItem
                        key={`federalSTate-${federalState.idFederalState}`}
                        value={federalState.idFederalState}
                      >
                        {`${federalState.FederalState}`}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <Collapse in={idFedearalState > 0}>
                  <TextField
                    //type="email"
                    variant='outlined'
                    label='Notar'
                    fullWidth
                    value={idNotaryUser < 0 ? '' : idNotaryUser}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setIdNotaryUser(Number(event.target.value));
                      setPayloadObject({
                        ...payloadObject,
                        idFederalStateLogin: null,
                      });
                    }}
                    required
                    select
                    size='small'
                  >
                    {users!
                      .filter(user => user.isNotary == true)
                      .filter(
                        user =>
                          federalStateLogins
                            .filter(
                              login => login.idFederalState === idFedearalState
                            )
                            .filter(
                              login => login.Notary_idUser === user.idUser
                            ).length > 0
                      )
                      .map(user => (
                        <MenuItem
                          key={`select-user-${user.idUser}`}
                          value={user.idUser}
                        >
                          {`${user.FirstName} ${user.LastName}`}
                        </MenuItem>
                      ))}
                  </TextField>
                </Collapse>
              </Grid>
              <Grid item xs={12}>
                <Collapse in={idNotaryUser > 0}>
                  <CustomeTextField
                    attr='idFederalStateLogin'
                    label='Zugang'
                    object={payloadObject}
                    setObject={setPayloadObject}
                    type='select'
                    null={payloadObject.idFederalStateLogin === null}
                  >
                    {federalStateLogins
                      .filter(login => login.isFirstStage == false)
                      .filter(login => login.idFederalState === idFedearalState)
                      .filter(login => login.Notary_idUser === idNotaryUser)
                      .map(login => (
                        <MenuItem
                          key={`idFederalStateLogin-${login.idFederalStateLogin}`}
                          value={login.idFederalStateLogin}
                        >
                          {login.Username} // {login.SecondName}
                        </MenuItem>
                      ))}
                  </CustomeTextField>
                </Collapse>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
      <Collapse in={payloadObject.idFederalStateLogin !== null}>
        <Box sx={{ m: 2 }}>
          <Card variant='outlined'>
            <Typography variant='caption' sx={{ ml: 1 }}>
              Suche
            </Typography>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CustomeTextField
                    label='Gericht'
                    attr='idDistrictCourt'
                    object={payloadObject}
                    disabled={
                      isResultLoading ||
                      (resultArray !== null && resultArray.length !== 0)
                    }
                    setObject={(payload: IPayload) => {
                      const testDistrictObject = districtCourtArray.find(
                        x => x.idDistrictCourt === payload.idDistrictCourt
                      );
                      if (testDistrictObject !== undefined) {
                        setPayloadObject({
                          ...payloadObject,
                          idDistrictCourt:
                            testDistrictObject['idDistrictCourt'],
                          Court: testDistrictObject['Court'],
                          idLandMarking: null,
                          Marking: null,
                        });
                      } else if (payload.idDistrictCourt === null) {
                        setPayloadObject({
                          ...payloadObject,
                          idDistrictCourt: null,
                          Court: null,
                          idLandMarking: null,
                          Marking: null,
                        });
                      }
                    }}
                    type='select'
                    null
                    required
                  >
                    {districtCourtArray.map(x => (
                      <MenuItem
                        key={`court-${x.idDistrictCourt}`}
                        value={x.idDistrictCourt}
                      >
                        {x.Court}
                      </MenuItem>
                    ))}
                  </CustomeTextField>
                </Grid>

                <Grid item xs={6}>
                  <CustomeTextField
                    label='Gemarkung'
                    attr='idLandMarking'
                    object={payloadObject}
                    disabled={
                      isResultLoading ||
                      (resultArray !== null && resultArray.length !== 0)
                    }
                    required
                    setObject={(payload: IPayload) => {
                      const testLandMarking = landMarkingArray.find(
                        x => x.idLandMarking === payload.idLandMarking
                      );

                      if (testLandMarking !== undefined) {
                        const testDistrictObject = districtCourtArray.find(
                          x =>
                            x.idDistrictCourt ===
                            testLandMarking?.idDistrictCourt
                        );
                        if (testDistrictObject !== undefined) {
                          setPayloadObject({
                            ...payloadObject,
                            idDistrictCourt:
                              testDistrictObject['idDistrictCourt'],
                            Court: testDistrictObject['Court'],
                            idLandMarking: testLandMarking.idLandMarking,
                            Marking: testLandMarking.LandMarking,
                          });
                        }
                      } else if (payload.idLandMarking === null) {
                        setPayloadObject({
                          ...payloadObject,
                          idLandMarking: null,
                          Marking: null,
                        });
                      }
                    }}
                    type='select'
                    null
                  >
                    {landMarkingArray
                      .filter(
                        x =>
                          payloadObject.idDistrictCourt === null ||
                          x.idDistrictCourt === payloadObject.idDistrictCourt
                      )
                      .sort((a, b) => (a.LandMarking > b.LandMarking ? 1 : -1))
                      .map(x => (
                        <MenuItem
                          key={`landmarking-${x.idLandMarking}`}
                          value={x.idLandMarking}
                        >
                          {x.LandMarking}{' '}
                          {payloadObject.idDistrictCourt === null && (
                            <>
                              {' '}
                              (
                              {
                                districtCourtArray.find(
                                  y => y.idDistrictCourt === x.idDistrictCourt
                                )?.Court
                              }
                              )
                            </>
                          )}
                        </MenuItem>
                      ))}
                  </CustomeTextField>
                </Grid>

                <Grid item xs={4}>
                  <CustomeTextField
                    label='Flur'
                    attr='Parcel'
                    object={payloadObject}
                    setObject={setPayloadObject}
                    disabled={
                      isResultLoading ||
                      (resultArray !== null && resultArray.length !== 0)
                    }
                    type='string'
                    null
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomeTextField
                    label='Flurstück'
                    attr='LandParcel'
                    object={payloadObject}
                    setObject={setPayloadObject}
                    disabled={
                      isResultLoading ||
                      (resultArray !== null && resultArray.length !== 0)
                    }
                    type='string'
                    null
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomeTextField
                    label='Lage'
                    attr='Street'
                    object={payloadObject}
                    setObject={setPayloadObject}
                    disabled={
                      isResultLoading ||
                      (resultArray !== null && resultArray.length !== 0)
                    }
                    type='string'
                    null
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomeTextField
                    label='Suchbegriff'
                    attr='SearchString'
                    object={payloadObject}
                    setObject={setPayloadObject}
                    disabled={
                      isResultLoading ||
                      (resultArray !== null && resultArray.length !== 0)
                    }
                    type='string'
                    null
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', float: 'right' }}>
                    <Collapse
                      in={
                        isResultLoading ||
                        (resultArray !== null && resultArray.length !== 0)
                      }
                    >
                      <Button
                        variant='outlined'
                        sx={{ float: 'right', mr: 2 }}
                        onClick={handleResetSearch}
                        disabled={
                          payloadObject.SearchString === null ||
                          payloadObject.SearchString === '' ||
                          payloadObject.idDistrictCourt === null ||
                          isResultLoading
                        }
                      >
                        Suchen Zurücksetzen
                      </Button>
                    </Collapse>
                    <Button
                      variant='outlined'
                      sx={{ float: 'right' }}
                      onClick={handleSearch}
                      disabled={
                        payloadObject.idDistrictCourt === null ||
                        payloadObject.idLandMarking === null ||
                        isResultLoading ||
                        (resultArray !== null && resultArray.length !== 0) ||
                        (payloadObject.LandParcel === null &&
                          payloadObject.SearchString === null)
                      }
                    >
                      Suchen
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {`State ist Loading: ${isResultLoading}`}
          <Collapse
            in={!wasSuccessfully || isResultLoading || resultArray !== null}
          >
            <Card variant='outlined' sx={{ mt: 3 }}>
              <Typography variant='caption' sx={{ ml: 1 }}>
                Grundbucheinträge
              </Typography>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {!wasSuccessfully ? (
                      <Alert severity='warning'>
                        Es ist ein Fehler aufgeretten!
                        <br />
                        Bitte versuchen Sie es später erneut.
                      </Alert>
                    ) : isResultLoading ? (
                      <>
                        <Typography>
                          Die Suche/das Laden kann mehrere Minuten in Anspruch
                          nehmen, bitte haben Sie Geduld...
                        </Typography>
                        <LoadingSpinner height='100%' />
                      </>
                    ) : resultArray?.length === 0 ? (
                      <>
                        <Typography>Die Suche ergab kein Treffer!</Typography>
                      </>
                    ) : (
                      <>
                        <Typography>
                          Einträge mit gleichen Grundbuch und Blattnummer werden
                          gemeinsam ausgewählt.{' '}
                        </Typography>
                        <Table sx={{ mt: 3 }} size='small'>
                          <TableHead>
                            <TableRow>
                              <TableCell></TableCell>
                              <TableCell>Grundbuchbez.</TableCell>
                              <TableCell>Blattnr.</TableCell>
                              <TableCell>Gemarkung</TableCell>
                              <TableCell>Flur</TableCell>
                              <TableCell>Flurstück</TableCell>
                              <TableCell>Lage</TableCell>
                              <TableCell>Auf.Nr.</TableCell>
                              <TableCell>Ges</TableCell>
                              <TableCell>Vorrname</TableCell>
                              <TableCell>Nachname</TableCell>
                              <TableCell>Geburtsname</TableCell>
                              <TableCell>Geburtstag</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {resultArray?.map((resultObj, idx) => (
                              <TableRow key={`landregister-res-${idx}`}>
                                <TableCell>
                                  <Checkbox
                                    checked={
                                      downloadPayload.find(
                                        x =>
                                          x.Landregister === x.Landregister &&
                                          x.SheetNumber === x.SheetNumber
                                      ) === undefined
                                        ? false
                                        : true
                                    }
                                    onChange={() => {
                                      if (
                                        downloadPayload.find(
                                          x =>
                                            x.Landregister === x.Landregister &&
                                            x.SheetNumber === x.SheetNumber
                                        ) === undefined
                                      ) {
                                        setDownloadPayload([
                                          ...downloadPayload,
                                          resultObj,
                                        ]);
                                      } else {
                                        setDownloadPayload([
                                          ...downloadPayload.filter(
                                            x =>
                                              x.Landregister !==
                                                x.Landregister &&
                                              x.SheetNumber !== x.SheetNumber
                                          ),
                                        ]);
                                      }
                                    }}
                                    inputProps={{
                                      'aria-label': 'controlled',
                                    }}
                                  />
                                </TableCell>
                                <TableCell>{resultObj.Landregister}</TableCell>
                                <TableCell>{resultObj.SheetNumber}</TableCell>
                                <TableCell>{resultObj.Marking}</TableCell>
                                <TableCell>
                                  {resultObj.CadastralDistrict}
                                </TableCell>
                                <TableCell>{resultObj.CadastralUnit}</TableCell>
                                <TableCell>{resultObj.Location}</TableCell>
                                <TableCell>{resultObj.OrderNumber}</TableCell>
                                <TableCell>{resultObj.Ges}</TableCell>
                                <TableCell>{resultObj.FirstName}</TableCell>
                                <TableCell>{resultObj.LastName}</TableCell>
                                <TableCell>{resultObj.Birthname}</TableCell>
                                <TableCell>{resultObj.Birthday}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant='outlined'
                      sx={{ float: 'right' }}
                      onClick={() => setIsOpenDownloadWarning(true)}
                      disabled={downloadPayload.length === 0 || isResultLoading}
                    >
                      Download
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Collapse>
          {/*
          <Box sx={{ mt: 5, alignItems: 'center' }}>
            <MasterportalViewer resultArray={resultArray} />
          </Box>
          */}
        </Box>
      </Collapse>
    </>
  );
};
